import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/admin/services/user.service';

@Component({
  selector: 'app-delete-user-modal',
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.scss'],
})
export class DeleteUserModalComponent implements OnInit {

  user: User;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  usernameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  firstNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  lastNameQuery: string = '';
  idCardNoQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;

  constructor(private modalController: ModalController, private userService: UserService) { }


  ngOnInit() {}

  removeUser() {
    this.userService.deleteUser(this.user.id).subscribe(res => {
      this.userService.getAllUsers({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
        usernameQuery: this.usernameQuery, firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery,
        idCardNoQuery: this.idCardNoQuery});
      this.dismissModal();
    },(err) => {
      console.error(err);
    });
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
